import { pinCode, popAndLegendCode, clusterAndLegendCode, orderLinesCode } from './mapsCode';
import { pinLayout, popAndLegendLayout, clusterAndLegendLayout, orderLinesLayout } from './mapsLayouts';

export const mapsSet = [
  {
    component: pinLayout,
    codeTemplate: pinCode,
    imagePath: 'pin.png',
    optionsGroup: [
      {
        label: 'Pin', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
  {
    component: popAndLegendLayout,
    codeTemplate: popAndLegendCode,
    imagePath: 'pop-and-legend.png',
    optionsGroup: [
      {
        label: 'Pop and Legend', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
  {
    component: clusterAndLegendLayout,
    codeTemplate: clusterAndLegendCode,
    imagePath: 'cluster-and-legend.png',
    optionsGroup: [
      {
        label: 'Cluster and Legend', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
  {
    component: orderLinesLayout,
    codeTemplate: orderLinesCode,
    imagePath: 'order-lines.png',
    optionsGroup: [
      {
        label: 'Order Lines', options: [
          { label: 'default', type: 'radio', options: {}},
        ]
      },
    ]
  },
];




// WEBPACK FOOTER //
// ./src/containers/components/Map/constants/mapsSet.js